import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CustomerHeader from "../components/CustomerHeader";
import CustomerFooter from "../components/CustomerFooter";
import "../App.css";

function PrivacyPolicy() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        width: "100%",
        overflowX: "hidden",
      }}
    >
      <CustomerHeader />

      {/* Hero Section */}
      <div
        style={{
          background: "linear-gradient(135deg, #2d6da3 0%, #4a90c6 100%)",
          color: "white",
          padding: isMobile ? "40px 16px" : "60px 40px",
          textAlign: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "24px" : "36px",
            marginBottom: "10px",
            fontWeight: "bold",
          }}
        >
          Privacy Policy
        </h1>
        <p
          style={{
            fontSize: isMobile ? "14px" : "16px",
            opacity: 0.95,
          }}
        >
          Last Updated: February 25, 2026
        </p>
      </div>

      {/* Main Content */}
      <div
        style={{
          flex: 1,
          maxWidth: "900px",
          width: "100%",
          margin: "0 auto",
          padding: isMobile ? "30px 16px" : "60px 40px",
          boxSizing: "border-box",
          overflowX: "hidden",
        }}
      >
        <section style={{ marginBottom: isMobile ? "32px" : "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "22px" : "24px",
              marginBottom: isMobile ? "12px" : "15px",
              color: "#1f2937",
              fontWeight: "700",
              lineHeight: "1.3",
            }}
          >
            1. Introduction
          </h2>
          <p
            style={{
              fontSize: isMobile ? "16px" : "16px",
              lineHeight: isMobile ? "1.7" : "1.8",
              color: "#4b5563",
              marginBottom: isMobile ? "16px" : "15px",
            }}
          >
            OGESTYLE is owned and operated by SOFTISS LLC. Throughout this
            Privacy Policy, "OGESTYLE," "we," "our," and "us" refer to SOFTISS
            LLC doing business as OGESTYLE.
          </p>
          <p
            style={{
              fontSize: isMobile ? "16px" : "16px",
              lineHeight: isMobile ? "1.7" : "1.8",
              color: "#4b5563",
              marginBottom: isMobile ? "16px" : "15px",
            }}
          >
            We are committed to protecting your personal information and your
            right to privacy. This Privacy Policy explains how we collect, use,
            disclose, and safeguard your information when you use our website,
            mobile application, and services (collectively, the "Services").
          </p>
          <p
            style={{
              fontSize: isMobile ? "16px" : "16px",
              lineHeight: isMobile ? "1.7" : "1.8",
              color: "#4b5563",
            }}
          >
            By using our Services, you consent to the collection and use of
            information in accordance with this Privacy Policy. If you do not
            agree with our policies and practices, please do not use our
            Services.
          </p>
        </section>

        <section style={{ marginBottom: isMobile ? "32px" : "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "22px" : "24px",
              marginBottom: isMobile ? "12px" : "15px",
              color: "#1f2937",
              fontWeight: "700",
              lineHeight: "1.3",
            }}
          >
            2. Information We Collect
          </h2>
          <h3
            style={{
              fontSize: isMobile ? "18px" : "18px",
              marginBottom: isMobile ? "10px" : "10px",
              color: "#374151",
              fontWeight: "600",
              lineHeight: "1.4",
            }}
          >
            2.1 Personal Information
          </h3>
          <p
            style={{
              fontSize: isMobile ? "16px" : "16px",
              lineHeight: isMobile ? "1.7" : "1.8",
              color: "#4b5563",
              marginBottom: isMobile ? "16px" : "15px",
            }}
          >
            When you register for an account, book services, or contact us, we
            may collect:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
              marginBottom: "15px",
            }}
          >
            <li>
              Name and contact information (email address, phone number, mailing
              address)
            </li>
            <li>Account credentials (username, password)</li>
            <li>
              Payment information (credit card details, billing address) -
              processed securely through Stripe
            </li>
            <li>
              Profile information (profile picture, preferences, service
              history)
            </li>
            <li>
              Booking information (appointment details, service selections,
              professional preferences)
            </li>
          </ul>

          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            2.2 SMS/Text Message Data
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            When you opt-in to receive SMS notifications:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
              marginBottom: "15px",
            }}
          >
            <li>We collect your mobile phone number</li>
            <li>We store your SMS consent status and preferences</li>
            <li>We track message delivery status for operational purposes</li>
            <li>We log opt-out requests to ensure compliance</li>
            <li>You may opt-out at any time by texting "STOP" to our number</li>
            <li>Message and data rates may apply</li>
          </ul>

          <h3
            style={{
              fontSize: isMobile ? "16px" : "18px",
              marginBottom: "10px",
              color: "#374151",
              fontWeight: "600",
            }}
          >
            2.3 Automatically Collected Information
          </h3>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            We automatically collect certain information when you use our
            Services:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>
              Device information (IP address, browser type, operating system)
            </li>
            <li>Usage data (pages visited, time spent, clickstream data)</li>
            <li>Location data (with your permission)</li>
            <li>Cookies and similar tracking technologies</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            3. How We Use Your Information
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            We use the information we collect to:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>Provide, maintain, and improve our Services</li>
            <li>Process your bookings and payments</li>
            <li>
              Send appointment confirmations, reminders, and updates via SMS and
              email
            </li>
            <li>Communicate with you about your account and services</li>
            <li>Personalize your experience and provide recommendations</li>
            <li>Analyze usage patterns and improve our platform</li>
            <li>
              Detect, prevent, and address technical issues and fraudulent
              activity
            </li>
            <li>Comply with legal obligations and resolve disputes</li>
            <li>Send marketing communications (with your consent)</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            4. SMS/Text Messaging (TCPA Compliance)
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            OGESTYLE provides SMS notification services for appointment-related
            communications. By providing your mobile phone number and opting in,
            you consent to receive:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
              marginBottom: "15px",
            }}
          >
            <li>Booking confirmations</li>
            <li>Appointment reminders</li>
            <li>Cancellation and rescheduling notifications</li>
            <li>Service updates and important account information</li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            <strong>Your Rights:</strong>
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
              marginBottom: "15px",
            }}
          >
            <li>Consent is not a condition of purchase</li>
            <li>Message frequency varies based on your bookings</li>
            <li>Message and data rates may apply</li>
            <li>Text STOP to opt-out at any time</li>
            <li>Text HELP for assistance</li>
            <li>Carriers are not liable for delayed or undelivered messages</li>
          </ul>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            For SMS support, contact us at support@ogestyle.com or
            +1-224-487-0006.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            5. Information Sharing and Disclosure
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            We may share your information with:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>
              <strong>Service Professionals:</strong> Your booking information
              with the professionals providing your services
            </li>
            <li>
              <strong>Business Partners:</strong> Salons, spas, and wellness
              businesses you book with
            </li>
            <li>
              <strong>Service Providers:</strong> Third-party companies that
              help us operate (payment processors, SMS providers, cloud hosting)
            </li>
            <li>
              <strong>Legal Requirements:</strong> When required by law, court
              order, or to protect our rights
            </li>
            <li>
              <strong>Business Transfers:</strong> In connection with a merger,
              acquisition, or sale of assets
            </li>
          </ul>
          <div
            style={{
              marginTop: "24px",
              padding: "20px",
              backgroundColor: "#f0f9ff",
              borderLeft: "4px solid #1a659e",
              borderRadius: "8px",
            }}
          >
            <p
              style={{
                fontSize: isMobile ? "15px" : "16px",
                lineHeight: "1.8",
                color: "#1f2937",
                fontWeight: "600",
                margin: 0,
              }}
            >
              <strong>Important:</strong> We do not sell, rent, or share your
              personal information with third parties for their marketing
              purposes. Your information is used solely to provide and improve
              our services to you.
            </p>
          </div>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            6. Data Security
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            We implement industry-standard security measures to protect your
            personal information, including encryption, secure servers, and
            access controls. However, no method of transmission over the
            Internet or electronic storage is 100% secure. While we strive to
            protect your information, we cannot guarantee its absolute security.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            7. Your Rights and Choices
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            You have the right to:
          </p>
          <ul
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginLeft: "20px",
            }}
          >
            <li>Access and review your personal information</li>
            <li>Update or correct your information</li>
            <li>Delete your account and associated data</li>
            <li>Opt-out of marketing communications</li>
            <li>Opt-out of SMS notifications (text STOP)</li>
            <li>Disable cookies through your browser settings</li>
            <li>Request a copy of your data (data portability)</li>
          </ul>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            8. Data Retention
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            We retain your personal information for as long as necessary to
            provide our Services, comply with legal obligations, resolve
            disputes, and enforce our agreements. When you delete your account,
            we will delete or anonymize your personal information within 90
            days, except where we are required to retain it for legal purposes.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            9. Children's Privacy
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            Our Services are not intended for children under 18 years of age. We
            do not knowingly collect personal information from children under
            18. If you are a parent or guardian and believe your child has
            provided us with personal information, please contact us
            immediately.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            10. Changes to This Privacy Policy
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            We may update this Privacy Policy from time to time. We will notify
            you of any material changes by posting the new Privacy Policy on
            this page and updating the "Last Updated" date. Your continued use
            of our Services after any changes constitutes your acceptance of the
            revised Privacy Policy.
          </p>
        </section>

        <section style={{ marginBottom: "40px" }}>
          <h2
            style={{
              fontSize: isMobile ? "20px" : "24px",
              marginBottom: "15px",
              color: "#1f2937",
            }}
          >
            11. Contact Us
          </h2>
          <p
            style={{
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
              marginBottom: "15px",
            }}
          >
            If you have questions or concerns about this Privacy Policy or our
            data practices, please contact us:
          </p>
          <div
            style={{
              background: "#f9fafb",
              padding: "20px",
              borderRadius: "8px",
              fontSize: isMobile ? "14px" : "16px",
              lineHeight: "1.8",
              color: "#4b5563",
            }}
          >
            <p style={{ marginBottom: "10px" }}>
              <strong>OGESTYLE</strong>
            </p>
            <p style={{ marginBottom: "10px" }}>Email: support@ogestyle.com</p>
            <p style={{ marginBottom: "10px" }}>Phone: +1-224-487-0006</p>
            <p>
              Website:{" "}
              <a href="https://www.ogestyle.com" style={{ color: "#2d6da3" }}>
                https://www.ogestyle.com
              </a>
            </p>
          </div>
        </section>

        <div
          style={{
            borderTop: "2px solid #e5e7eb",
            paddingTop: "30px",
            textAlign: "center",
          }}
        >
          <Link
            to="/"
            style={{
              display: "inline-block",
              background: "linear-gradient(135deg, #f59e0b 0%, #f97316 100%)",
              color: "white",
              padding: isMobile ? "12px 24px" : "14px 32px",
              borderRadius: "8px",
              textDecoration: "none",
              fontSize: isMobile ? "14px" : "16px",
              fontWeight: "600",
            }}
          >
            Back to Home
          </Link>
        </div>
      </div>

      <CustomerFooter />
    </div>
  );
}

export default PrivacyPolicy;
